<template>
    <input class="form-control" v-model="numeric_value" @keypress="check" ref="numberInput"  @blur="focusOut" type="text"/>
</template>

<script>
import {isNumber} from "lodash";

function countDecimals(value) {
  const string = String(value)

  if (string.indexOf('.') < 0) {
    return 0
  }

  return string.split(".")[1].length || 0;
}
export default {
  name: "AppDecimalInput",
  props: {
    value: {
      default: null
    },
    allowDecimal: {
      type: Boolean,
      default: true
    },
    decimals: {
      type: Number,
      default: 2
    },
    nullable: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      numeric_value: 0
    };
  },
  methods: {
    focusOut(){
      if(isNumber(this.numeric_value) && this.decimals){
        this.numeric_value =  this.numeric_value.toFixed(this.decimals)
        this.$emit('input', this.numeric_value)
      }

    },
    check(e) {
      const value = this.numeric_value ? String(this.numeric_value) : ""
      this.lastKey = e.key

      if (!e.key.match(/[0-9.]/)) {
        e.preventDefault()
      }

      if (e.key === 'e') {
        e.preventDefault()
      }

      if (!this.allowDecimal && e.key === '.') {
        e.preventDefault()
      }

      if (this.allowDecimal && e.key === '.' && (value.match(/\./g) || []).length > 0) {
        e.preventDefault()
      }

      if (e.key === '-' && (value.match(/-/g) || []).length > 0) {
        e.preventDefault()
      }

      if (e.key === "." && value.trim().length === 0) {
        e.preventDefault()
      }

      if (e.key === "." && value.trim().length === 1 && value.indexOf("-") === 0) {
        e.preventDefault()
      }
    },
  },
  watch: {
    numeric_value(newValue, oldValue) {
      if (typeof newValue === 'string' && newValue.trim() === "-" && this.lastKey === "-") return

      if (newValue === null || newValue === undefined || newValue === "" || newValue === " " || newValue === "-") {
        if (this.nullable) {
          this.$emit('input', null)
        } else {
          this.numeric_value = this.min !== Number.NEGATIVE_INFINITY ? this.min : oldValue ? oldValue : 0;
          this.$refs.numberInput.select()
        }
      } else if (newValue < this.min || newValue > this.max) {
        this.numeric_value = oldValue
      } else if (countDecimals(newValue) > this.decimals) {
        this.numeric_value = Number(newValue).toFixed(this.decimals)
      } else {
        this.$emit('input', Number(newValue))
      }
    },
    value(value) {
      this.numeric_value = value
    }
  },
  created() {
    this.numeric_value = this.value
  }
}
</script>

<style scoped>

</style>
